import React from 'react'
import './style.sass'
import PropTypes from 'prop-types'
import FieldWrapper from '../FieldWrapper'

const ToggleCheckbox = ({ displayName, description, errorMessage, disabled, value, onChange }) => {
  return (
    <FieldWrapper
      displayName={displayName}
      description={description} 
      errorMessage={errorMessage}
      disabled={disabled}
    >
      <div className="toggle-checkbox-container">
        <div className="toggle-checkbox-inner-container">
            {value === 'true' || value === true ? 
              <span style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}> Yes</span> : 
              <span style={{ cursor: disabled ? 'not-allowed' : 'pointer', left: 45 }}>No</span>}
            <input 
              id={displayName}
              name={displayName} 
              checked={(value === 'true' || value === true) ? true : false}
              onChange={onChange ? (e) => onChange(e.target.checked) : () => {}}
              type="checkbox" 
              disabled={disabled} 
              style={{ cursor: disabled ? 'not-allowed' : 'pointer' }} 
            />
            <label style={{ cursor: disabled ? 'not-allowed' : 'pointer' }} htmlFor={displayName}>Toggle</label>
        </div>
      </div>
    </FieldWrapper>
  )
}

ToggleCheckbox.propTypes = {
  displayName: PropTypes.string,
  description: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
}

export default ToggleCheckbox
